import * as actions from 'state/actions/CMT/ClanManagement'
import { BATTLE_TYPES, RANDOM_BATTLE_TYPES } from 'utils/clan_management/battles'
import { BLOCK_TYPES } from 'utils/clan_management/constants'
import { PERIOD_TYPES } from 'utils/clan_management/periods'

const initialData = {
    isError: false,
    fetchingCounter: 0,
    transactionInProcessing: false,
    blockType: BLOCK_TYPES.CLAN_MODES,
    [BLOCK_TYPES.CLAN_MODES]: {
        period: PERIOD_TYPES.MONTH,
    },
    [BLOCK_TYPES.STATISTICS]: {
        battleType: BATTLE_TYPES.RANDOM,
        period: PERIOD_TYPES.ALL,
        randomBattleType: RANDOM_BATTLE_TYPES.DEFAULT,
    },
    urls: {},
}

const reducers = {
    [actions.CLAN_MANAGEMENT_START_FETCHING]: (state) => ({
        ...state,
        fetchingCounter: state.fetchingCounter + 1,
    }),
    [actions.CLAN_MANAGEMENT_STOP_FETCHING]: (state) => ({
        ...state,
        fetchingCounter: state.fetchingCounter - 1,
    }),
    [actions.CLAN_MANAGEMENT_CHANGE_BLOCK_TYPE]: (state, action) => ({
        ...state,
        blockType: action.blockType,
    }),
    [actions.CLAN_MANAGEMENT_CHANGE_BATTLE_TYPE]: (state, action) => {
        const blockData = {
            ...state[state.blockType],
            battleType: action.battleType,
        }
        if (action.battleType === BATTLE_TYPES.RANKED) {
            blockData.period = PERIOD_TYPES.ALL
        }
        return {
            ...state,
            [state.blockType]: blockData,
        }
    },
    [actions.CLAN_MANAGEMENT_CHANGE_PERIOD]: (state, action) => ({
        ...state,
        [state.blockType]: {
            ...state[state.blockType],
            period: action.period,
        },
    }),
    [actions.CLAN_MANAGEMENT_CHANGE_RANDOM_BATTLE_TYPE]: (state, action) => {
        const blockData = {
            ...state[state.blockType],
            randomBattleType: action.randomBattleType,
        }
        if (action.randomBattleType === RANDOM_BATTLE_TYPES.EPIC) {
            blockData.period = PERIOD_TYPES.ALL
        }
        return {
            ...state,
            [state.blockType]: blockData,
        }
    },
    [actions.CLAN_MANAGEMENT_UPDATE]: (state) => ({
        ...state,
        isError: false,
        fetchingCounter: state.fetchingCounter - 1,
    }),
    [actions.CLAN_MANAGEMENT_FETCH_ERROR]: (state) => ({
        ...state,
        isError: true,
        fetchingCounter: state.fetchingCounter - 1,
    }),
    [actions.CLAN_MANAGEMENT_TOGGLE_CLAN_IN_TRANSACTION]: (state) => ({
        ...state,
        transactionInProcessing: !state.transactionInProcessing,
    }),
}

export default (state = initialData, action) => {
    const reducer = reducers[action.type]
    if (!reducer) return state
    return reducer(state, action)
}



// WEBPACK FOOTER //
// ./state/reducers/CMT/ClanManagement.js